import React from 'react';
import PropTypes from 'prop-types';
import { TabShapes } from './tab-consts';
import * as S from './styled';

export const TabsSwitcher = ({ selectedValue, value, onChange, options, shape = TabShapes.OUTLINED, testId }) => {
  const visibleOptions = options?.filter(option => !option.hidden);
  const handleChange = val => e => onChange?.(e, val);
  return (
    !!visibleOptions?.length && (
      <S.TabsWrapper data-testid={testId} $shape={shape?.toUpperCase()}>
        {visibleOptions.map(
          ({ value: optionValue, label, labelComponent, disabled, testId: optionId, className, ariaLabel }) => (
            <S.TabWrapper
              key={optionValue}
              className={className}
              data-testid={optionId || `${testId}-${optionValue}`}
              aria-label={label || ariaLabel}
              onClick={disabled ? undefined : handleChange(optionValue)}
              disabled={disabled}
              $selected={(selectedValue ?? value) === optionValue}
              data-value={optionValue}
              data-text={label}
              $shape={shape?.toUpperCase()}>
              {labelComponent || label}
            </S.TabWrapper>
          )
        )}
      </S.TabsWrapper>
    )
  );
};

TabsSwitcher.propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.any]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
      labelComponent: PropTypes.node,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
      testId: PropTypes.string,
      className: PropTypes.string,
      ariaLabel: PropTypes.string
    })
  ).isRequired,
  testId: PropTypes.string,
  shape: PropTypes.oneOf(['OUTLINED', 'FLAT', 'FILLED', 'FILTER', 'VIEW_SWITCHER'])
};
